/**
 * Layout de DESKTOP (≥1024px) das telas de entrada (escolha de acesso, permissões, intro):
 * painel da marca à esquerda + a tela num card à direita.
 *
 * No celular/tablet devolve os filhos sem nenhum embrulho — a tela é idêntica ao app.
 * Os textos do painel são os mesmos destaques da intro do app (components/intro).
 */
import iconeT from "@/assets/images/icon_foreground.png";
import logoBranco from "@/assets/images/logo_tirvu_horizontal_branco.png";
import * as Application from "@/platform/application";
import { MaterialIcons } from "@/ui/icons";
import { useDesktop } from "@/ui/useMediaQuery";
import type { ReactNode } from "react";
import s from "./EntradaDesktop.module.css";
import { T, TC, TM } from "@/utils/i18n";

const DESTAQUES = [
  { icone: "schedule", titulo: TC("Controle de ponto moderno"), texto: TC("Facilidade, tecnologia e precisão para o seu dia.") },
  { icone: "face", titulo: TC("Ponto com reconhecimento facial"), texto: TC("Segurança e rapidez usando seu rosto. Sem complicação.") },
  { icone: "cloud-off", titulo: TC("Funciona offline, sincroniza depois"), texto: TC("Registre ponto sem internet e mantenha tudo em ordem.") },
  { icone: "insights", titulo: TC("Controle total da sua jornada"), texto: TC("Jornadas, horários e histórico sempre acessíveis.") },
] as const;

export default function EntradaDesktop({ children, cardLargo = false }: { children: ReactNode; cardLargo?: boolean }) {
  const desktop = useDesktop();
  if (!desktop) return <>{children}</>;
  return (
    <div className={s.raiz}>
      <aside className={s.marca}>
        <img src={iconeT} alt="" className={s.marcaDagua} draggable={false} />
        <img src={logoBranco} alt="Tirvu" className={s.logo} draggable={false} />
        <div className={s.chamada}>
          <h1 className={s.titulo}>{T("Sua jornada de trabalho, simples e na palma da mão.")}</h1>
          <span className={s.subtitulo}>{T("O mesmo Tirvu+ do celular, agora no computador.")}</span>
        </div>
        <ul className={s.destaques}>
          {DESTAQUES.map((d) => (
            <li key={d.titulo} className={s.destaque}>
              <div className={s.destaqueIcone}>
                <MaterialIcons name={d.icone} size={22} color="#fff" />
              </div>
              <div className={s.destaqueTextos}>
                <span className={s.destaqueTitulo}>{TM(d.titulo)}</span>
                <span className={s.destaqueTexto}>{TM(d.texto)}</span>
              </div>
            </li>
          ))}
        </ul>
        <span className={s.rodape}>Tirvu+ {Application.nativeApplicationVersion ? `v${Application.nativeApplicationVersion}` : ""}</span>
      </aside>
      <main className={s.lado}>
        <div className={cardLargo ? `${s.card} ${s.cardLargo}` : s.card}>{children}</div>
      </main>
    </div>
  );
}
